import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { useResponsive } from '@sg/garnish';
import { PointsReward } from '@sg/graphql-schema';
import { LoyaltyReward } from '@sg/shared-fe/features/loyalty';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyHomeRewardsGrid = (props: LoyaltyHomeUnlockableRewardsProps) => {
  const { availablePoints, pointRewards, onStartOrder } = props;

  // ─── Responsive ────────────────────────────────────────────────────────────

  const { screenDimensions } = useResponsive();
  const shouldUseTwoColumns = screenDimensions.width < 1064;
  const gridElementStyle = shouldUseTwoColumns ? styles.twoColumnsCell : styles.threeColumnsCell;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.rewardsGrid}>
      {pointRewards.map((reward) => {
        return (
          <View key={reward.id} style={gridElementStyle}>
            <LoyaltyReward
              startOrderPalette="primary"
              size="lg"
              style={styles.reward}
              id={reward.id}
              title={reward.name}
              imageUrl={reward.assetUrl}
              points={reward.points}
              showPointsToUnlock={availablePoints < reward.points}
              onStartOrder={availablePoints >= reward.points ? onStartOrder : undefined}
            />
          </View>
        );
      })}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  rewardsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: '1.5%',
    rowGap: theme.spacing['4'],
  },
  twoColumnsCell: {
    width: '48.5%',
    alignItems: 'center',
  },
  threeColumnsCell: {
    width: '32.3333%',
    alignItems: 'center',
  },
  reward: {
    width: '100%',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyHomeUnlockableRewardsProps = {
  availablePoints: number;
  pointRewards: readonly Omit<PointsReward, 'displayName'>[];
  onStartOrder: () => void;
};
